import type { MembershipPlan } from "@/libs/facilityApi";
import type { MembershipPlanAvailabilityChange } from "./membership-plans";
import Button from "@mui/material/Button";

/** Presentation-only sale control; server status and capability stay authoritative. */
export interface MembershipPlanAvailabilityControlProps {
  plan: MembershipPlan;
  disabled: boolean;
  onChange: (event: MembershipPlanAvailabilityChange) => void;
}

export function MembershipPlanAvailabilityControl({ plan, disabled, onChange }: MembershipPlanAvailabilityControlProps) {
  if (plan.status !== "active" && plan.status !== "inactive") return null;
  const status = plan.status === "active" ? "inactive" : "active";
  const label = status === "inactive" ? "Pause new purchases" : "Resume new purchases";
  return (
    <Button disabled={disabled} size="small" variant="outlined"
      aria-label={`${label} for ${plan.name}`}
      onClick={() => onChange({ facilityId: plan.facility_id, planId: plan.plan_id, status })}>
      {label}
    </Button>
  );
}
